import { render } from "./CLoading.vue?vue&type=template&id=6f008e1c&scoped=true&ts=true"
import script from "./CLoading.vue?vue&type=script&lang=ts"
export * from "./CLoading.vue?vue&type=script&lang=ts"

import "./CLoading.vue?vue&type=style&index=0&id=6f008e1c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Silverfish-Vue/Silverfish-Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f008e1c"]])

export default __exports__